module.exports = __webpack_public_path__ + "img/ic_finished.9f9251ea.svg";